/* eslint-disable max-len */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useMemo } from 'react';
import { connect, useDispatch } from 'react-redux';
import _, { cloneDeep } from 'lodash';
import { useForm, Controller } from 'react-hook-form';
import { makeStyles, styled, useTheme } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import IconButton from '@material-ui/core/IconButton';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import CircularProgress from '@material-ui/core/CircularProgress';
import {
  Stepper, Step, StepButton, Box, Button, Container,
} from '@material-ui/core';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import deLocale from 'date-fns/locale/es';
import moment from 'moment';
import CustomInput from '../../../../components/form/CustomInput';
import CustomSelect from '../../../../components/form/CustomSelect';
import AutocompleteGoogleMaps from '../../../../components/form/AutocompeteGoogleMaps/CustomAutocompleteGoogleMaps';
import { Rules } from '../../../../helpers/RHFRules';
import {
  getPurchaseOrderParametersAction,
} from '../../../../actions/general.action';
import {
  saveContractAction, getManagersAction, getAppParametersContractsAction,
  getContractDataAction, getContractCustomerInfoAction, getContractSupervisiorInfoAction,
  getInformationAgreementAction, modifyInformationAgreementAction,
} from '../../../../actions/license.action';
import { getPackagesContractsAction } from '../../../../actions/home.action';
import { getDocumentTypesContracts } from '../../../../helpers/documentsTypes';
import { LICENSE_LOADING } from '../../../../types/license.type';
import AutoCompleteAddressDepartmentCity from '../../../../components/form/AutocompeteGoogleMaps/AutoCompleteAddressDepartmentCity';
import AlertConfirm from '../../../../components/crosscutting/confirmationWindows/AlertConfirm';
import Loading from '../../../../components/crosscutting/Loading';
import { getBlackListEmailsAction } from '../../../../actions/email.action';
import { getServicesAction } from '../../../../actions/service.action';
import CertificationServicesEdit from './CertificationServicesEdit';
import FirmayaServicesEdit from './FirmayaServicesEdit';
import WarningIcon from '../../../../components/IconsLibrary/WarningIcon';
import SuccesfullIcon from '../../../../components/IconsLibrary/SuccesfullIcon';
import ObservationsConfirm from '../../../../components/crosscutting/confirmationWindows/ObservationsConfirm';
import AlertPeriodicity from './AlertPeriodicity';

const StyledStepButton = styled(StepButton)(({ theme }) => ({
  '& .MuiStepIcon-root': {
    color: theme.palette.primary.main,

    // Número: color base = paso no seleccionado
    '& .MuiStepIcon-text': {
      fill: '#FFFF',
      fontSize: '14px',
      fontWeight: 600,
    },
    '&.MuiStepIcon-active': {
      color: theme.palette.primary.main,
      '& .MuiStepIcon-text': {
        fill: theme.palette.primary.contrastText, // número del paso actual
      },
    },
    '&.MuiStepIcon-completed': {
      color: theme.palette.success.main,
    },
  },
}));

const getMulishText = (fontWeight, color, fontSize) => ({
  fontFamily: 'Mulish, sans-serif',
  fontSize,
  fontWeight,
  color,
});

/**
 * Set dinamic styles for Dialog
 * @param {*} theme mui material theme
 * @param {*} firstImageIcon First icon
 * @param {*} minWidth Dialog width
 * @param {*} minHeight Dialog Heigth
 * @param {*} marginTopImage margon of first Image
 * @param {*} minWidthButtonAcept width accept button
 * @returns a object with dinamic styles
 */
const alertStyles = (theme, firstImageIcon, minWidth, minHeight, marginTopImage, minWidthButtonAcept) => ({
  styleMessage: {
    ...getMulishText(700, '#575756', '18px'),
    paddingBottom: 15,
  },
  dialogStyle: { minWidth, minHeight },
  firstImage: firstImageIcon,
  firstImageStyles: {
    display: 'block',
    margin: 'auto',
    marginTop: marginTopImage,
  },
  styleTitle: {
    fontFamily: 'Mulish, sans-serif',
    fontSize: '20px',
    fontWeight: 700,
    marginTop: '-25px',
  },
  styleButtonCancel: {
    backgroundColor: '#FFFFFF',
    color: theme?.backOffice?.contracts?.btnSteps?.backgroundColor,
    border: `1px solid ${theme?.backOffice?.contracts?.btnSteps?.backgroundColor}`,
  },
  styleButtonAcept: {
    minWidth: minWidthButtonAcept,
  },
});

const useStyles = makeStyles((theme) => ({
  paper: {
    background: 'linear-gradient(#FFFFFFCC, #ffffff)',
    borderRadius: '30px',
    opacity: 1,
    padding: '5px',
    marginTop: '20px',
  },
  title: {
    fontWeight: 700,
    fontSize: '34px',
    paddingTop: '32px',
    paddingLeft: '32px',
    color: theme.backOffice.contracts.title.color,
  },
  titleForm: {
    color: theme.backOffice.contracts.titleForm.color,
    textAlign: 'left',
    letterSpacing: '0px',
    opacity: '1',
    fontWeight: 'bold',
  },
  titleFormAgreement: {
    color: theme.backOffice.contracts.titleForm.color,
    textAlign: 'left',
    letterSpacing: '0px',
    opacity: '1',
    fontWeight: 'bold',
    marginTop: '5px',
  },
  typeInput: {
    '& .MuiOutlinedInput-root': {
      position: 'relative',
      borderRadius: '10px',
      boxShadow: '1px 5px 5px #d7d7d7',
      color: `${theme.backOffice.contracts.form.text} !important`,
      '& svg': {
        color: theme.backOffice.contracts.tableProducts.colorIcon,
      },
      // Normal
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.backOffice.contracts.form.border,
      },
      // Enfocado
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.backOffice.contracts.form.text,
      },
      // Error: va al final para ganarle al enfocado y al hover
      '&.Mui-error .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.error.main,
      },
      // Deshabilitado: va al final para ganarle a los demás estados
      '&.Mui-disabled': {
        backgroundColor: '#FFFFFF',
        boxShadow: 'none',
        color: `${theme.backOffice.contracts.form.disabled} !important`,
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: theme.backOffice.contracts.form.disabled,
        },
        '& svg': {
          color: theme.backOffice.contracts.form.disabled,
        },
      },
    },
    '& .MuiInputLabel-root.Mui-focused': {
      color: theme.backOffice.contracts.form.text,
    },
    '& .MuiInputLabel-root.Mui-disabled': {
      color: theme.backOffice.contracts.form.disabled,
    },
  },
  paperGroup: {
    backgroundColor: '#fff',
    marginTop: 24,
    marginBottom: 32,
    borderRadius: 10,
    border: `1px solid ${theme.home.cart.discountText.color}`,
    padding: 36,
  },
  dateCustom: {
    '& .MuiIconButton-root': {
      color: theme.palette.primary.main,
    },
    '& .MuiOutlinedInput-root': {
      position: 'relative',
      borderRadius: '10px',
      boxShadow: '1px 5px 5px #d7d7d7',
      color: `${theme.backOffice.contracts.form.text} !important`,
      '& svg': {
        color: theme.backOffice.contracts.tableProducts.colorIcon,
      },
      // Normal
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.backOffice.contracts.form.border,
      },
      // Enfocado
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.backOffice.contracts.form.text,
      },
      // Error: va al final para ganarle al enfocado y al hover
      '&.Mui-error .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.error.main,
      },
    },
    '& .MuiInputLabel-root.Mui-focused': {
      color: theme.backOffice.contracts.form.text,
    },
  },
  subGridButtons: {
    display: 'flex',
    justifyContent: 'start',
  },
  subGridButtonsCancel: {
    display: 'flex',
    justifyContent: 'end',
  },
  btnSubmit: {
    marginLeft: 0,
    fontSize: 16,
    height: '44px',
    borderRadius: 10,
    fontWeight: 100,
    border: `1px solid ${theme.backOffice.contracts.btnSteps.backgroundColor}`,
    color: theme.backOffice.contracts.btnSteps.backgroundColor,
    backgroundColor: 'white',
    '&:disabled': {
      opacity: 0.4,
      fontWeight: 100,
      backgroundColor: 'white',
      color: theme.backOffice.contracts.btnSteps.backgroundColor,
    },
    '&:hover': {
      backgroundColor: '#E0E0E0',
      boxShadow: '#00000033 0px 2.98931px 1.03206px -1.98931px, #00000024 0px 2.02137px 2.03206px 0px, #0000001F 0px 1px 5.05343px 0px',
    },
  },
  btnSubmitCancel: {
    marginLeft: 0,
    fontSize: 16,
    width: '120px',
    height: '44px',
    borderRadius: 10,
    fontWeight: 100,
    border: `1px solid ${theme.backOffice.contracts.btnSteps.backgroundColor}`,
    color: theme.backOffice.contracts.btnSteps.backgroundColor,
    backgroundColor: 'white',
    '&:disabled': {
      opacity: 0.4,
      fontWeight: 100,
      backgroundColor: 'white',
      color: theme.backOffice.contracts.btnSteps.backgroundColor,
    },
    '&:hover': {
      backgroundColor: '#E0E0E0',
      boxShadow: '#00000033 0px 2.98931px 1.03206px -1.98931px, #00000024 0px 2.02137px 2.03206px 0px, #0000001F 0px 1px 5.05343px 0px',
    },
  },
  btnBlueSubmit: {
    marginLeft: 10,
    fontSize: 16,
    borderRadius: 10,
    backgroundColor: theme.backOffice.contracts.btnSteps.backgroundColor,
    color: 'white',
    fontWeight: 100,
    '&:disabled': {
      opacity: 0.4,
      fontWeight: 100,
      backgroundColor: theme.backOffice.contracts.btnSteps.backgroundColor,
      color: 'white',
    },
  },
  scrollBar: {
    '&.MuiTableContainer-root': {
      scrollbarColor: `${theme.backOffice.contracts.tableProducts.backgroundColor} #fff`,
    },
  },
  tableHead: {
    /* width: '828px', */
    height: '40px',
    background: 'var(--unnamed-color-009bdd) 0% 0% no-repeat padding-box',
    borderRadius: '10px',
    opacity: 1,
    color: '#FFF',
    backgroundColor: theme.backOffice.contracts.tableProducts.backgroundColor,
  },
  tableCell: {
    fontWeight: 'bold',
    fontSize: '16px',
    ...theme.backOffice.contracts.tableProducts,
  },
  AlertStyleTitle: {
    fontFamily: 'Mulish, sans-serif',
    fontSize: 700,
    fontWeight: '20px',
    marginTop: '-25px',
  },
  AlertFirstImageStyles: {
    display: 'block',
    margin: 'auto',
    width: '96px',
    height: 'auto',
    marginTop: 40,
  },
  buttonProgress: {
    color: '#ffff',
    position: 'center',
    marginBottom: '-5px',
  },
}));

const personType = [
  { value: 'J', label: 'Persona Juridica' },
  { value: 'N', label: 'Persona Natural' },
];

const steps = ['Información Contrato', 'Información Cliente', 'Información Supervisor', 'Servicios Contratados', 'Periodicidad de alertas'];

const EditAgreements = (props) => {
  const {
    statesAndCities, citiesServGoogleAssistant, getPurchaseOrderParameters, getServices, documentTypes, tenant,
    getManagers, gestorType, getPackagesContracts, productType, getBlackListEmails, riskOfficers,
    emailsInBalckList, getAppParametersContracts, listPaymentTypeContracts, listDocumentTypeContracts,
    listValidityTypeContracts, listDeviceTypeContracts, listCredentialDeliveryContracts, applicationInfo,
    parameterMaxReassignmentQuota, startDateParams, transformedListMaxValidityAmountContracts, decodedToken,
    servicesCombo, getContractSupervisiorInfo, showLegalRepresentativeContract, getInformationAgreement,
    getInformationAgreementResponse, uniqueId, messageStyle, modifyInformationAgreement, modifyInformationAgreementResponse,
    loading, permissions, alertPeriodicityParams, parameterMaxValidityContract, riskOfficerRole, listCredentialParams,
  } = props;
  const {
    handleSubmit, errors, control, getValues, setValue, clearErrors, watch, trigger, setError,
  } = useForm({
    mode: 'onChange',
  });
  const {
    handleSubmit: handleSubmitProducts,
    errors: errorsProducts,
    control: controlProducts,
    setValue: setValueProducts,
    reset: resetProduct,
    clearErrors: clearErrorsProducts,
    getValues: getValuesProducts,
  } = useForm({
    mode: 'onChange',
  });
  const theme = useTheme();
  const dispatch = useDispatch();
  const watchDocTypeSer = watch('documentTypeIdService');
  const watchDocTypeDocSupervisor = watch('documentTypeIdSupervisor');
  const watchDocuNumberSupervisor = watch('documentNumberSupervisor');
  const watchLegalDocTypeSer = watch('legalDocumentTypeIdService');
  const watchTickerService = watch('ticketService');
  const watchObservations = watch('observations');

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [activeStep, setActiveStep] = useState(0);
  const [activeStepAux, setActiveStepAux] = useState(0);
  const [formData, setFormData] = useState({});
  const [formCopy, setFormCopy] = useState({});
  const [personTypeService, setPersonTypeService] = React.useState('N');
  const [optionsAddressService, setOptionsAddressService] = React.useState([]);
  const [addressMapsService, setAddressMapsService] = React.useState(null);
  const [inputAddressServiceValue, setInputAddressServiceValue] = React.useState('');
  const [, setGeoCodeService] = React.useState({ lat: null, lng: null });
  const [departaments, setDepartaments] = useState([]);
  const [citiesService, setCitiesService] = useState([]);
  const [valueDepartamentService, setValueDepartamentService] = React.useState(null);
  const [valueCityService, setValueCityService] = React.useState(null);
  const [servicesToAdd, setServicesToAdd] = React.useState([]);
  const [servicesToAddCopy, setServicesToAddCopy] = React.useState([]);
  const classes = useStyles();
  const [addressMapsSon, setAddressMapsSon] = useState(null);
  const [inputAddressSonValue, setInputAddressSonValue] = useState('');
  const [isEditing, setIsEditing] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [credentialsOptions, setCredentialsOptions] = useState(listCredentialDeliveryContracts);
  const [deviceTypeOptions, setDeviceTypeOptions] = useState([]);
  const [openAlertConfirmTab, setOpenAlertConfirmTab] = useState(false);
  const [disabledButton, setDisabledButton] = useState(false);
  const [openAlertConfirmTicket, setOpenAlertConfirmTicket] = useState(false);
  const [lastValidValueQuantityProducts, setLastValidValueQuantityProducts] = useState('');
  const [invalidDomains, setInvalidDomains] = useState([]);
  const [serviceNameSelected, setServiceNameSelected] = useState(null);
  const [componentNameSelected, setComponentNameSelected] = useState(null);
  const [isSwitchEnabled, setIsSwitchEnabled] = useState(false);
  const [isRequiredSupervision, setIsRequiredSupervision] = useState(false);
  const [isGetInformationOnce, setIsGetInformationOnce] = useState(false);
  const [isGetInformationOnceAddress, setIsGetInformationOnceAddress] = useState(false);
  const [isEditAgreement, setIsEditAgreement] = useState(false);
  const [isCheckedButtonChanges, setIsCheckedButtonChanges] = useState(false);
  const [countryCodeUnique, setCountryCodeUnique] = React.useState('CO');
  const [messagesAlertView, setMessagesAlertView] = useState({});
  const [messagesAlertViewOpen, setMessagesAlertViewOpen] = useState(false);
  const [isLoadingInfo, setIsLoadingInfo] = useState(true);
  const [selectInhibitList, setSelectInhibitList] = useState(false);
  const [hasSupervisorEmail, setHasSupervisorEmail] = useState(true);

  const [optionsAddressSupervisor, setOptionsAddressSupervisor] = useState([]);
  const [departamentsSupervisor, setDepartamentsSupervisor] = useState([]);
  const [, setGeoCodeSupervisor] = useState({
    lat: null,
    lng: null,
  });
  const [valueDepartamentSupervisor, setValueDepartamentSupervisor] = useState(null);
  const [valueCitySupervisor, setValueCitySupervisor] = useState(null);
  const [citiesSupervisor, setCitiesSupervisor] = useState([]);
  const [serviceOptions, setServiceOptions] = React.useState([]);
  const dialogColorIcon = theme?.miplan?.buttonCard?.backgroundColor;
  const succesfullColor = theme?.miplan?.hoverButtonCard?.backgroundColor;

  const OwnWarningIcon = useMemo(() => (
    <WarningIcon color={dialogColorIcon} />
  ), [dialogColorIcon]);

  const OwnSuccesfullIcon = useMemo(() => (
    <SuccesfullIcon color={succesfullColor} />
  ), [succesfullColor]);

  const setCityCustomerServiceId = (dptoId, dptoName, cityId, cityName, checkServ) => {
    if (checkServ) {
      let dptoServ = {};
      if (dptoId > 0) {
        dptoServ = statesAndCities.itemsStatesList.find((d) => d.value === dptoId);
      } else {
        dptoServ = statesAndCities.itemsStatesList.find((d) => d.text === dptoName);
        // dptoBilling = statesAndCities.itemsStatesList.find((d) => dptoName.include(d.text));
      }

      if (dptoServ) {
        setValueDepartamentService(dptoServ);
        setValue('departmentIdService', dptoServ);
        clearErrors('departmentIdService');
      }

      let newCities = {};
      if (dptoId > 0) {
        newCities = statesAndCities.statesList.find((d) => d.id === dptoId);
      } else {
        newCities = statesAndCities.statesList.find((d) => d.stateName === dptoName);
      }
      if (newCities) {
        setCitiesService(newCities.city);

        let cityBilling = {};
        if (cityId > 0) {
          cityBilling = newCities.city.find((d) => d.id === cityId);
        } else {
          cityBilling = newCities.city.find((d) => d.cityName === cityName);
        }

        if (cityBilling) {
          setValueCityService(cityBilling);
          setValue('departmentIdService', dptoServ.value);
          clearErrors('departmentIdService');
          setValue('cityIdService', cityBilling.id);
          clearErrors('cityIdService');
        }
      }
    }
  };

  const clearSupervisorInfo = () => {
    setValue('namesSupervisor', '');
    setValue('lastNameSupervisor', '');
    setValue('CustomFulladdressService', '');
    setAddressMapsSon(null);
    setInputAddressSonValue('');
    setValue('CustomDepartmentIdService', '');
    setValueDepartamentSupervisor(null);
    setValue('CustomCityIdService', '');
    setValueCitySupervisor(null);
    setValue('cellphoneNumberSupervisor', '');
    setValue('emailSupervisor', '');
    setValue('supervisorPosition', '');
    setFormData((prevData) => ({
      ...prevData,
      namesSupervisor: '',
      lastNameSupervisor: '',
      CustomFulladdressService: '',
      CustomDepartmentIdService: '',
      CustomCityIdService: '',
      cellphoneNumberSupervisor: '',
      emailSupervisor: '',
      supervisorPosition: '',
    }));
  };
  const loadSupervisorInfo = async (documentType, documentNumber, countryCode) => {
    clearErrors();
    if (!documentNumber) {
      clearSupervisorInfo();
      return;
    }
    const response = await getContractSupervisiorInfo(documentType, documentNumber, countryCode);
    if (!response) {
      clearSupervisorInfo();
      setHasSupervisorEmail(false);
    } else {
      setValue('namesSupervisor', response.firstName);
      setValue('lastNameSupervisor', response.lastName);
      setValue('CustomFulladdressService', response.fullAddress);
      setAddressMapsSon(response.fullAddress);
      setInputAddressSonValue(response.fullAddress);
      const newCities = statesAndCities.statesList.find((d) => d.id === response.departmentId);
      if (newCities) {
        const mappedDepartment = {
          ...newCities,
          value: newCities.id,
          text: newCities.stateName,
        };
        setValue('CustomDepartmentIdService', mappedDepartment);
        setValueDepartamentSupervisor(mappedDepartment);
        const matchedCity = newCities.city.find((c) => c.id === response.cityId);
        if (matchedCity) {
          setValue('CustomCityIdService', matchedCity.id);
          setValueCitySupervisor(matchedCity);
        }
      } else {
        setValue('CustomDepartmentIdService', '');
        setValueDepartamentSupervisor(null);
        setValue('CustomCityIdService', '');
        setValueCitySupervisor(null);
      }
      setValue('cellphoneNumberSupervisor', response.phoneNumber);
      setValue('emailSupervisor', response.email);
      setValue('supervisorPosition', response.jobTitle);
      setFormData((prev) => ({
        ...prev,
        documentTypeIdSupervisor: documentType,
        documentNumberSupervisor: documentNumber,
        namesSupervisor: response.firstName || '',
        lastNameSupervisor: response.lastName || '',
        CustomFulladdressService: response.fullAddress,
        CustomDepartmentIdService: response.departmentId || '',
        CustomCityIdService: response.cityId || '',
        cellphoneNumberSupervisor: response.phoneNumber || '',
        emailSupervisor: response.email || '',
        supervisorPosition: response.jobTitle || '',
      }));
      clearErrors();
      setHasSupervisorEmail(true);
    }
  };

  useEffect(() => {
    setIsEditAgreement(true);
    getServices();
    getBlackListEmails();
  }, []);

  useEffect(() => {
    const fetchAgreementData = async () => {
      if (listDocumentTypeContracts.length > 0) {
        setIsLoadingInfo(true);
        const uniqueCountry = listDocumentTypeContracts[0].country;
        setCountryCodeUnique(uniqueCountry);
        await getPurchaseOrderParameters(uniqueCountry);
        setIsLoadingInfo(false);
      }
    };
    fetchAgreementData();
  }, [listDocumentTypeContracts]);

  useEffect(() => {
    if (statesAndCities) {
      setDepartaments(statesAndCities.itemsStatesList.sort((a, b) => {
        const x = a.text < b.text ? -1 : 1;
        return x;
      }));
    }
  }, [statesAndCities]);

  /**
   * emails in black list retrived of redux
   * then parse into a unique list
   */
  useEffect(() => {
    if (emailsInBalckList !== null && emailsInBalckList !== undefined) {
      const invalidsDomains = [];
      emailsInBalckList.forEach((email) => {
        invalidsDomains.push(email.regla);
      });
      setInvalidDomains(invalidsDomains);
    }
  }, [emailsInBalckList]);

  useEffect(() => {
    if (servicesCombo.length > 0) {
      let selectedApps = [];
      Object.keys(decodedToken).forEach((key) => {
        if (key.includes('PRIVILEGE')) {
          const privileges = decodedToken[key];
          if (Array.isArray(privileges)) {
            // eslint-disable-next-line no-plusplus
            for (let i = 0; i < privileges.length; i++) {
              const privilege = privileges[i];
              if (permissions?.includes('showAllProducts')) {
                selectedApps = [];
                const apps = servicesCombo.filter((serviceItemCombo) => serviceItemCombo.isContractFullAccess === true); //
                if (apps.length > 0) {
                  // eslint-disable-next-line no-loop-func
                  apps.forEach((app) => {
                    if (app.name) {
                      selectedApps.push(app.name);
                    }
                  });
                }
                break;
              }
              const matchApp = privilege.match(/LICENSE_([A-Z]+)_/);
              if (matchApp && matchApp[1]) {
                selectedApps.push(matchApp[1]);
              }
            }
          }
        }
      });
      const filteredServices = servicesCombo.filter((serviceItemCombo) => selectedApps.includes(serviceItemCombo.name));
      const serviceOption = filteredServices.map((serviceItemCombo) => ({
        value: serviceItemCombo.value,
        label: serviceItemCombo.label,
        name: serviceItemCombo.name,
        nameContract: serviceItemCombo.nameContract,
        contractedServices: serviceItemCombo.contractedServices,
        requiresSupervision: serviceItemCombo.requiresSupervision,
      }));
      setServiceOptions(serviceOption);
    }
  }, [servicesCombo, decodedToken]);

  /**
   * Validate if domain is not in black list
   */
  const validateEmail = (value) => {
    if (!value) {
      return true;
    }
    // Verify if email have a domain in black list
    const domain = value.split('@')[1];
    if (domain && invalidDomains.includes(`@${domain}`)) {
      return 'El dominio de correo ingresado no es permitido.';
    }
    return true;
  };

  useEffect(() => {
    if (citiesServGoogleAssistant && citiesServGoogleAssistant.deptoName !== null) {
      setCityCustomerServiceId(
        0, citiesServGoogleAssistant.deptoName, 0, citiesServGoogleAssistant.cityName, true,
      );
    } else if (addressMapsService && optionsAddressService.length > 3) {
      if (!valueDepartamentService) {
        setValueDepartamentService(null);
        setValue('departmentIdService', '');
      }
      if (!valueCityService) {
        setValueCityService(null);
        setValue('cityIdService', '');
      }
    }
  }, [citiesServGoogleAssistant]);

  useEffect(() => {
    if (Object.keys(formData).length > 0) {
      Object.keys(formData).forEach((key) => {
        setValue(key, formData[key]);
      });
    }
  }, [formData, setValue, activeStep]);

  useEffect(() => {
    if (!valueDepartamentService) {
      setValue('departmentIdService', '');
    }
  }, [valueDepartamentService]);

  useEffect(() => {
    if (!valueCityService) {
      setValue('cityIdService', '');
    }
  }, [valueCityService]);

  const handleNext = async () => {
    setIsCheckedButtonChanges(true);
    setOpenAlertConfirmTicket(true);
  };

  const setDocumentTypeSupervisor = (event) => {
    const { value } = event.target;
    if (event.target.name === 'documentTypeIdSupervisor') {
      setValue('documentNumberSupervisor', '');
      setValue('namesSupervisor', '');
      setValue('lastNameSupervisor', '');
      setValue('CustomFulladdressService', '');
      setAddressMapsSon(null);
      setInputAddressSonValue('');
      setValue('CustomDepartmentIdService', '');
      setValueDepartamentSupervisor(null);
      setValue('CustomCityIdService', '');
      setValueCitySupervisor(null);
      setValue('cellphoneNumberSupervisor', '');
      setValue('emailSupervisor', '');
      setValue('supervisorPosition', '');
      setFormData((prevData) => ({
        ...prevData,
        documentTypeIdSupervisor: value,
        documentNumberSupervisor: '',
        namesSupervisor: '',
        lastNameSupervisor: '',
        CustomFulladdressService: '',
        CustomDepartmentIdService: '',
        CustomCityIdService: '',
        cellphoneNumberSupervisor: '',
        emailSupervisor: '',
        supervisorPosition: '',
      }));
      setValue('documentTypeIdSupervisor', value);
    }
    return value;
  };

  const getDocumentsTypesSupervisor = () => {
    const documents = [];
    getDocumentTypesContracts(documentTypes, 'N', serviceNameSelected, listDocumentTypeContracts, true).map(
      (td) => (
        documents.push({
          value: td.value,
          label: td.text,
        })
      ),
    );
    return documents;
  };

  const setGestorType = (event) => {
    const { value } = event.target;
    if (event.target.name === 'gestorService') {
      setFormData((prevData) => ({
        ...prevData,
        gestorService: value,
      }));
      setValue('gestorService', value);
    }
    return value;
  };

  const setRiskOfficerType = (event) => {
    const { value } = event.target;
    if (event.target.name === 'riskOfficer') {
      setFormData((prevData) => ({
        ...prevData,
        riskOfficer: value,
      }));
      setValue('riskOfficer', value);
    }
    return value;
  };

  const setPaymentType = (event) => {
    const { value } = event.target;
    if (event.target.name === 'paymentService') {
      setFormData((prevData) => ({
        ...prevData,
        paymentService: value,
      }));
      setValue('paymentService', value);
    }
    return value;
  };

  const validateDocument = (persontype, watchDocType) => {
    if (watchDocType === 6 || watchDocType === 10 || watchDocType === 13) {
      return Rules.pasaporteCustomMessage('El campo debe ser alfanumérico, mínimo 5 y máximo 15 caracteres.');
    } if (watchDocType === 4 && persontype === 'J') {
      return Rules.tipoDocumentoNIT;
    }
    return Rules.otrosDocumentosCustomMessage('El campo debe ser numérico, mínimo 5 y máximo 15 caracteres.');
  };

  const handleChangeStateCustomerServiceId = (idDepartament) => {
    setValueCityService(null);
    const newCities = statesAndCities.statesList.find((d) => d.id === idDepartament);
    if (newCities) {
      setCitiesService(newCities.city.sort((a, b) => {
        const x = a.cityName < b.cityName ? -1 : 1;
        return x;
      }));
    }
    return idDepartament;
  };

  const handleSwitchChange = (event) => {
    setIsSwitchEnabled(event.target.checked);
  };

  /**
   * Metodo validar digito de verificación
   * @param {*} referencia digito de verificacion
   * @returns retorna caja de digito de verificació
   */
  const boxCheckDigit = (referencia) => (
    <>
      <Grid item xs={1} sm={1}>
        <Box pt={1} style={{ textAlign: 'center' }}>-</Box>
      </Grid>
      <Grid item xs={2} sm={2}>
        <Controller
          as={(
            <TextField
              size="small"
              label="Dv"
              disabled
              variant="outlined"
              style={{ color: 'red' }}
              className={classes.typeInput}
            />
          )}
          name={referencia}
          control={control}
          disabled={isEditAgreement}
          defaultValue={getInformationAgreementResponse?.customer?.dvService || ''}
        />
      </Grid>
    </>
  );

  useEffect(() => {
    setIsGetInformationOnce(false);
    setIsGetInformationOnceAddress(false);
    getInformationAgreement(uniqueId);
  }, []);

  const setValueRoskOfficer = (serviceName) => {
    if (serviceName === 'LSTINHIB') {
      setSelectInhibitList(true);
    }
  };

  useEffect(() => {
    if (riskOfficerRole) {
      getManagers(riskOfficerRole, 'OFFICERS');
    }
  }, [riskOfficerRole]);

  useEffect(() => {
    const fetchAgreementData = async () => {
      if (Object.keys(getInformationAgreementResponse).length > 0) {
        setIsEditAgreement(true);
        if (!isGetInformationOnce) {
          const filteredServices = serviceOptions.find((serviceItemCombo) => serviceItemCombo.value === getInformationAgreementResponse?.contract?.serviceName);
          if (filteredServices) {
            await getAppParametersContracts(filteredServices?.nameContract, 'ParametersDocumentType', 'ParametersValidityType', 'ParametersStartDate', 'ParameterMaxReassignmentQuota', 'ParameterMaxValidityAmount', 'ParameterMaxContractValidity', 'ParameterRiskOfficerRole');
            await getManagers(`LICENSE_${filteredServices?.nameContract}_COMERCIALMANAGER`, 'MANAGERS');
            setValueRoskOfficer(filteredServices?.nameContract, getInformationAgreementResponse?.contract?.riskOfficerId);
            await getPackagesContracts(filteredServices?.name, true, true);
            dispatch({ type: LICENSE_LOADING, payload: false });
            setServiceNameSelected(filteredServices?.nameContract);
            setComponentNameSelected(filteredServices?.contractedServices);
            setIsRequiredSupervision(filteredServices?.requiresSupervision);
            setValue('contractService', getInformationAgreementResponse?.contract?.contractService);
            setValue('serviceName', getInformationAgreementResponse?.contract?.serviceName);
            setValue('startDate', moment(getInformationAgreementResponse?.contract?.startDate));
            setStartDate(moment(getInformationAgreementResponse?.contract?.startDate));
            setValue('endDate', getInformationAgreementResponse?.contract?.endDate);
            setEndDate(getInformationAgreementResponse?.contract?.endDate);
            setValue('gestorService', getInformationAgreementResponse?.contract?.gestorService);
            setValue('riskOfficer', getInformationAgreementResponse?.contract?.riskOfficerId);
            setValue('paymentService', getInformationAgreementResponse?.contract?.paymentService);
            setValue('personTypeService', getInformationAgreementResponse?.customer?.personTypeService);
            setPersonTypeService(getInformationAgreementResponse?.customer?.personTypeService);
            setValue('documentTypeIdService', getInformationAgreementResponse?.customer?.documentTypeIdService);
            setValue('documentNumberService', getInformationAgreementResponse?.customer?.documentNumberService);
            setValue('dvService', getInformationAgreementResponse?.customer?.dvService);
            setValue('legalNameService', getInformationAgreementResponse?.customer?.legalNameService);
            setValue('firstNameService', getInformationAgreementResponse?.customer?.firstNameService);
            setValue('lastNameService', getInformationAgreementResponse?.customer?.lastNameService);
            setValue('fulladdressService', getInformationAgreementResponse?.customer?.fulladdressService);
            setInputAddressServiceValue(getInformationAgreementResponse?.customer?.fulladdressService);
            setAddressMapsService(getInformationAgreementResponse?.customer?.fulladdressService);
            setValue('departmentIdService', getInformationAgreementResponse?.customer?.departmentIdService);
            setValueDepartamentService(getInformationAgreementResponse?.customer?.departmentIdService);
            setValue('cityIdService', getInformationAgreementResponse?.customer?.cityIdService);
            setValue('cellphoneNumberService', getInformationAgreementResponse?.customer?.cellphoneNumberService);
            setValue('emailService', getInformationAgreementResponse?.customer?.emailService);

            // Supervisor

            setValue('documentTypeIdSupervisor', getInformationAgreementResponse?.supervisor?.documentTypeIdSupervisor);
            setValue('documentNumberSupervisor', getInformationAgreementResponse?.supervisor?.documentNumberSupervisor);
            setValue('namesSupervisor', getInformationAgreementResponse?.supervisor?.namesSupervisor);
            setValue('lastNameSupervisor', getInformationAgreementResponse?.supervisor?.lastNameSupervisor);
            setValue('CustomFulladdressService', getInformationAgreementResponse?.supervisor?.CustomFulladdressService);
            setAddressMapsSon(getInformationAgreementResponse?.supervisor?.CustomFulladdressService);
            setInputAddressSonValue(getInformationAgreementResponse?.supervisor?.CustomFulladdressService);
            setValue('CustomDepartmentIdService', getInformationAgreementResponse?.supervisor?.CustomDepartmentIdService);
            setValueDepartamentSupervisor(getInformationAgreementResponse?.supervisor?.CustomDepartmentIdService);
            setValue('CustomCityIdService', getInformationAgreementResponse?.supervisor?.CustomCityIdService);
            setValueCitySupervisor(getInformationAgreementResponse?.supervisor?.CustomCityIdService);
            setValue('cellphoneNumberSupervisor', getInformationAgreementResponse?.supervisor?.cellphoneNumberSupervisor);
            setValue('emailSupervisor', getInformationAgreementResponse?.supervisor?.emailSupervisor);
            setValue('supervisorPosition', getInformationAgreementResponse?.supervisor?.supervisorPosition);
            switch (filteredServices?.contractedServices) {
              case 'isComponentECD': {
                const servicesAdd = getInformationAgreementResponse?.contractedServices?.map((service) => ({
                  isExist: true,
                  isUpdate: false,
                  credentialsDeliveryType: service.credentialsDeliveryType,
                  deviceType: service.deviceTypeId,
                  productService: service.packageCode,
                  reassignmentQuota: service.reassignmentQuota,
                  quantityToAddService: service.totalQuantity,
                  validityAmount: service.validityPeriod,
                  validityService: service.validityType,
                  licenseId: service.licenseId,
                  identifierCode: service.identifierCode,
                  isUnlimited: service.isUnlimited,
                }));
                setServicesToAdd((prev) => [...prev, ...servicesAdd]);
                setServicesToAddCopy((prev) => [...prev, ...servicesAdd]);
                break;
              }
              case 'isComponentServices': {
                const servicesAdd = getInformationAgreementResponse?.contractedServices?.map((service) => ({
                  isExist: true,
                  isUpdate: false,
                  isSwitchEnabled: service.isUnlimited,
                  productService: service.packageCode,
                  quantityToAddService: service.totalQuantity,
                  validityAmount: service.validityPeriod,
                  validityService: service.validityType,
                  licenseId: service.licenseId,
                  identifierCode: service.identifierCode,
                  isUnlimited: service.isUnlimited,
                }));
                setServicesToAdd((prev) => [...prev, ...servicesAdd]);
                setServicesToAddCopy((prev) => [...prev, ...servicesAdd]);
                break;
              }
              default:
                break;
            }
            setFormData((prevData) => ({
              ...prevData,
              ...getInformationAgreementResponse?.contract,
              ...getInformationAgreementResponse?.customer,
              ...getInformationAgreementResponse?.supervisor,
              startDate: moment(getInformationAgreementResponse?.contract?.startDate),
              endDate: moment(getInformationAgreementResponse?.contract?.endDate),
              userAlertOptions: {
                ...getInformationAgreementResponse.userAlertOptions,
              },
            }));
            setFormCopy((prevData) => ({
              ...prevData,
              ...getInformationAgreementResponse?.contract,
              ...getInformationAgreementResponse?.customer,
              ...getInformationAgreementResponse?.supervisor,
              startDate: moment(getInformationAgreementResponse?.contract?.startDate),
              endDate: moment(getInformationAgreementResponse?.contract?.endDate),
              userAlertOptions: {
                ...getInformationAgreementResponse.userAlertOptions,
              },
            }));
            setIsGetInformationOnce(true);
          }
        }
        if (!isGetInformationOnceAddress) {
          if (statesAndCities) {
            // Informacion del supervisor direcciones
            const newCities = statesAndCities?.statesList?.find((d) => d.id === getInformationAgreementResponse?.supervisor?.CustomDepartmentIdService);
            if (newCities) {
              const mappedDepartment = {
                ...newCities,
                value: newCities.id,
                text: newCities.stateName,
              };
              setValue('CustomDepartmentIdService', mappedDepartment);
              setValueDepartamentSupervisor(mappedDepartment);
            }
            const matchedCity = newCities?.city?.find((c) => c.id === getInformationAgreementResponse?.supervisor?.CustomCityIdService);
            if (matchedCity) {
              setValue('CustomCityIdService', matchedCity.id);
              setValueCitySupervisor(matchedCity);
            }
            setIsGetInformationOnceAddress(true);
          }
        }
        if (statesAndCities) {
          // Informacion del cliente direcciones
          setCityCustomerServiceId(getInformationAgreementResponse?.customer?.departmentIdService, null, getInformationAgreementResponse?.customer?.cityIdService, null, true);
        }
      }
    };
    fetchAgreementData();
  }, [getInformationAgreementResponse, activeStep, getValues, isGetInformationOnce, isGetInformationOnceAddress, serviceOptions]);

  const formatNumberWithCommas = (value) => {
    const num = Number(value);
    return !Number.isNaN(num) ? num.toLocaleString('en-US') : 'Dato inválido';
  };

  // eslint-disable-next-line consistent-return
  const selectComponent = () => {
    switch (componentNameSelected) {
      case 'isComponentECD':
        return (
          <CertificationServicesEdit
            productType={productType}
            listDeviceTypeContracts={listDeviceTypeContracts}
            listValidityTypeContracts={listValidityTypeContracts}
            transformedListMaxValidityAmountContracts={transformedListMaxValidityAmountContracts}
            parameterMaxReassignmentQuota={parameterMaxReassignmentQuota}
            listCredentialDeliveryContracts={listCredentialDeliveryContracts}
            setValueProducts={setValueProducts}
            getValuesProducts={getValuesProducts}
            resetProduct={resetProduct}
            clearErrorsProducts={clearErrorsProducts}
            controlProducts={controlProducts}
            errorsProducts={errorsProducts}
            handleSubmitProducts={handleSubmitProducts}
            theme={theme}
            classes={classes}
            deviceTypeOptions={deviceTypeOptions}
            setDeviceTypeOptions={setDeviceTypeOptions}
            lastValidValueQuantityProducts={lastValidValueQuantityProducts}
            setLastValidValueQuantityProducts={setLastValidValueQuantityProducts}
            isEditing={isEditing}
            setIsEditing={setIsEditing}
            servicesToAdd={servicesToAdd}
            setServicesToAdd={setServicesToAdd}
            selectedIndex={selectedIndex}
            setSelectedIndex={setSelectedIndex}
            credentialsOptions={credentialsOptions}
            setCredentialsOptions={setCredentialsOptions}
            formatNumberWithCommas={formatNumberWithCommas}
            listCredentialParams={listCredentialParams}
          />
        );
      case 'isComponentServices':
        return (
          <FirmayaServicesEdit
            productType={productType}
            listValidityTypeContracts={listValidityTypeContracts}
            transformedListMaxValidityAmountContracts={transformedListMaxValidityAmountContracts}
            setValueProducts={setValueProducts}
            getValuesProducts={getValuesProducts}
            resetProduct={resetProduct}
            clearErrorsProducts={clearErrorsProducts}
            controlProducts={controlProducts}
            errorsProducts={errorsProducts}
            handleSubmitProducts={handleSubmitProducts}
            theme={theme}
            classes={classes}
            lastValidValueQuantityProducts={lastValidValueQuantityProducts}
            setLastValidValueQuantityProducts={setLastValidValueQuantityProducts}
            isEditing={isEditing}
            setIsEditing={setIsEditing}
            servicesToAdd={servicesToAdd}
            setServicesToAdd={setServicesToAdd}
            selectedIndex={selectedIndex}
            setSelectedIndex={setSelectedIndex}
            isSwitchEnabled={isSwitchEnabled}
            handleSwitchChange={handleSwitchChange}
            setIsSwitchEnabled={setIsSwitchEnabled}
            formatNumberWithCommas={formatNumberWithCommas}
            messageStyle={messageStyle}
            formData={formData}
          />
        );
      default:
        break;
    }
  };

  const handleCancel = (handleCancelModifyAction = false) => {
    setServicesToAdd(servicesToAddCopy);
    setFormData(_.cloneDeep(formCopy));
    setStartDate(formCopy?.startDate);
    setEndDate(formCopy?.endDate);
    setValue('CustomFulladdressService', formCopy?.CustomFulladdressService);
    setAddressMapsSon(formCopy?.CustomFulladdressService);
    setInputAddressSonValue(formCopy?.CustomFulladdressService);
    if (statesAndCities) {
      const newCities = statesAndCities?.statesList?.find((d) => d.id === formCopy?.CustomDepartmentIdService);
      if (newCities) {
        const mappedDepartment = {
          ...newCities,
          value: newCities.id,
          text: newCities.stateName,
        };
        setValue('CustomDepartmentIdService', mappedDepartment);
        setValueDepartamentSupervisor(mappedDepartment);
      }
      const matchedCity = newCities?.city?.find((c) => c.id === formCopy?.CustomCityIdService);
      if (matchedCity) {
        setValue('CustomCityIdService', matchedCity.id);
        setValueCitySupervisor(matchedCity);
      }
    }
    const optionsAddress = [];

    optionsAddress.push({
      description: formCopy?.CustomFulladdressService,
      structured_formatting: {
        main_text: formCopy?.CustomFulladdressService,
        main_text_matched_substrings: [
          {
            length: 0,
            offset: 0,
          },
        ],
        secondary_text: '',
      },
    });
    setOptionsAddressSupervisor(optionsAddress);
    if (optionsAddress.length > 0) {
      setAddressMapsSon(optionsAddress[0]);
    }
    clearErrors();
    if (handleCancelModifyAction) {
      setTimeout(() => {
        if (!isCheckedButtonChanges) setActiveStep(activeStepAux);
        setOpenAlertConfirmTab(false);
        setOpenAlertConfirmTicket(false);
      }, 100);
    }
  };

  const onChangeDepartmentSupervisor = (data) => {
    setFormData((prevData) => ({
      ...prevData,
      CustomDepartmentIdService: data.value,
    }));
  };

  const onChangeCitySupervisor = (data) => {
    setFormData((prevData) => ({
      ...prevData,
      CustomCityIdService: data.id,
    }));
  };

  useEffect(() => {
    if (activeStep === 2) {
      const departmentValue = typeof valueDepartamentSupervisor === 'object' && valueDepartamentSupervisor !== null
        ? valueDepartamentSupervisor.value
        : valueDepartamentSupervisor;
      setFormData((prevData) => ({
        ...prevData,
        CustomDepartmentIdService: departmentValue || '',
      }));
    }
  }, [formData.CustomFulladdressService, valueDepartamentSupervisor, activeStep]);

  useEffect(() => {
    if (activeStep === 2) {
      const cityValue = typeof valueCitySupervisor === 'object' && valueCitySupervisor !== null
        ? valueCitySupervisor.id
        : valueCitySupervisor;
      setFormData((prevData) => ({
        ...prevData,
        CustomCityIdService: cityValue || '',
      }));
    }
  }, [formData.CustomFulladdressService, valueCitySupervisor, activeStep]);
  /**
   * If delivery frecuency is diary alert delivery days must be empty
   * @param {*} userAlertOptions current user alert options
   * @returns array of current delivery days or empty
   */
  const modifyNotifications = (userAlertOptions) => {
    const alertDelivery = userAlertOptions?.alertDeliveryDays;
    const deliveryF = userAlertOptions?.deliveryFrecuency;
    if (alertDelivery && deliveryF) {
      if (deliveryF === 'D') {
        return [];
      }
    }
    return alertDelivery;
  };

  const modifyUserAlertOptions = () => {
    setFormData((prevData) => ({
      ...prevData,
      userAlertOptions: {
        ...prevData.userAlertOptions,
        alertDeliveryDays: modifyNotifications(formData?.userAlertOptions),
      },
    }));
  };

  useEffect(() => {
    let timer;
    if (Object.keys(modifyInformationAgreementResponse).length > 0) {
      if (!isCheckedButtonChanges) setActiveStep(activeStepAux);
      setOpenAlertConfirmTab(false);
      setOpenAlertConfirmTicket(false);
      setDisabledButton(false);
      if (modifyInformationAgreementResponse.statusCode === 200) {
        setMessagesAlertView({
          tituloModal: '¡Convenio actualizado!',
          messageAlert: alertStyles(theme, OwnSuccesfullIcon, '508px', '284px', 65),
          isOnlyMessage: true,
          showClose: false,
        });
        modifyUserAlertOptions();
        setFormCopy(cloneDeep(formData));
        switch (componentNameSelected) {
          case 'isComponentECD': {
            const addServices = modifyInformationAgreementResponse?.result?.contractedServices?.map((service) => ({
              isExist: true,
              isUpdate: false,
              credentialsDeliveryType: service.credentialsDeliveryType,
              deviceType: service.deviceTypeId,
              productService: service.packageCode,
              reassignmentQuota: service.reassignmentQuota,
              quantityToAddService: service.totalQuantity,
              validityAmount: service.validityPeriod,
              validityService: service.validityType,
              licenseId: service.licenseId,
              identifierCode: service.identifierCode,
              isUnlimited: service.isUnlimited,
            }));
            setServicesToAdd(addServices);
            setServicesToAddCopy(_.cloneDeep(addServices));
            break;
          }
          case 'isComponentServices': {
            const addServices = modifyInformationAgreementResponse?.result?.contractedServices?.map((service) => ({
              isExist: true,
              isUpdate: false,
              isSwitchEnabled: service.isUnlimited,
              productService: service.packageCode,
              quantityToAddService: service.totalQuantity,
              validityAmount: service.validityPeriod,
              validityService: service.validityType,
              licenseId: service.licenseId,
              identifierCode: service.identifierCode,
              isUnlimited: service.isUnlimited,
            }));
            setServicesToAdd(addServices);
            setServicesToAddCopy(_.cloneDeep(addServices));
            break;
          }
          default:
            break;
        }
        setMessagesAlertViewOpen(true);
        setValue('CustomFulladdressService', formData?.CustomFulladdressService);
        setAddressMapsSon(formData?.CustomFulladdressService);
        setInputAddressSonValue(formData?.CustomFulladdressService);
        if (statesAndCities) {
          // Informacion del supervisor direcciones
          const newCities = statesAndCities?.statesList?.find((d) => d.id === formData?.CustomDepartmentIdService);
          if (newCities) {
            const mappedDepartment = {
              ...newCities,
              value: newCities.id,
              text: newCities.stateName,
            };
            setValue('CustomDepartmentIdService', mappedDepartment);
            setValueDepartamentSupervisor(mappedDepartment);
          }
          const matchedCity = newCities?.city?.find((c) => c.id === formData?.CustomCityIdService);
          if (matchedCity) {
            setValue('CustomCityIdService', matchedCity.id);
            setValueCitySupervisor(matchedCity);
          }
        }
        const optionsAddress = [];

        optionsAddress.push({
          description: formData?.CustomFulladdressService,
          structured_formatting: {
            main_text: formData?.CustomFulladdressService,
            main_text_matched_substrings: [
              {
                length: 0,
                offset: 0,
              },
            ],
            secondary_text: '',
          },
        });
        setOptionsAddressSupervisor(optionsAddress);
        if (optionsAddress.length > 0) {
          setAddressMapsSon(optionsAddress[0]);
        }
        timer = setTimeout(() => {
          setMessagesAlertViewOpen(false);
        }, 4000);
      } else {
        setMessagesAlertView({
          tituloModal: 'No se pudo actualizar el convenio',
          messageAlert: alertStyles(theme, OwnWarningIcon, '508px', '284px', 45, '25%'),
          handleAccept: () => { setMessagesAlertViewOpen(false); setFormData(formCopy); setServicesToAdd(servicesToAddCopy); setStartDate(formCopy?.startDate); setEndDate(formCopy?.endDate); },
          mensajeModal: modifyInformationAgreementResponse?.statusDetails?.[0]?.description || 'Se ha presentado un error al actualizar el convenio.',
          textButtonAcept: 'Entendido',
          showClose: false,
        });
        setMessagesAlertViewOpen(true);
      }
    }
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [modifyInformationAgreementResponse]);

  const onChangeFulladdressSupervisor = (data) => {
    setFormData((prevData) => ({
      ...prevData,
      CustomFulladdressService: data?.description,
    }));
    const optionsAddress = [];

    optionsAddress.push({
      description: data?.description,
      structured_formatting: {
        main_text: data?.description,
        main_text_matched_substrings: [
          {
            length: 0,
            offset: 0,
          },
        ],
        secondary_text: '',
      },
    });
    setOptionsAddressSupervisor(optionsAddress);
  };

  const handleConfirmChecked = () => {
    setOpenAlertConfirmTab(false);
    setOpenAlertConfirmTicket(true);
  };

  const handleConfirmTicket = () => {
    if (!watchTickerService) {
      setError('ticketService', {
        type: 'required',
        message: 'Campo obligatorio',
      });
    }
    if (!watchObservations) {
      setError('observations', {
        type: 'required',
        message: 'Campo obligatorio',
      });
    }
    if (errors.ticketService || errors.observations) {
      return;
    }
    setDisabledButton(true);
    modifyInformationAgreement(activeStep, formData, watchTickerService, watchObservations, uniqueId, serviceNameSelected, isRequiredSupervision, componentNameSelected, servicesToAdd, listDeviceTypeContracts, listDocumentTypeContracts[0]?.countryCode || 'COL');
  };

  const handleCancelModify = () => {
    setServicesToAdd(servicesToAddCopy);
    handleCancel(true);
  };

  const handleCancelModifyTicket = () => {
    setServicesToAdd(servicesToAddCopy);
    handleCancel(true);
  };

  const getLoading = () => (
    <>
      <Grid item xs={1}>
        <CircularProgress size={17} className={classes.buttonProgress} />
      </Grid>
    </>
  );

  const renderStepContent = (step) => {
    switch (step) {
      case 0:
        return (
          <>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Typography align="left" className={classes.titleForm} style={{ marginBottom: 20 }} variant="h6">
                  Información contrato
                </Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <Grid item xs={12}>
                  <InputLabel />
                  <CustomSelect
                    label="Producto"
                    name="serviceName"
                    options={serviceOptions}
                    control={control}
                    required
                    disabled={isEditAgreement}
                    rule={Rules.required}
                    error={errors}
                    styleFromHelperText={{ style: { marginRight: 10 } }}
                    classes={classes.typeInput}
                  />
                </Grid>
              </Grid>
              <Grid item xs={12} md={6}>
                <CustomInput
                  label="Número de oportunidad"
                  name="contractService"
                  control={control}
                  error={errors}
                  required
                  disabled={isEditAgreement}
                  styleFromHelperText={{ style: { marginRight: 10 } }}
                  // rule={(e) => validateContract(e.target.value)}
                  rule={{
                    ...Rules.required,
                  }}
                  inputProps={{
                    maxLength: 100,
                  }}
                  classes={classes.typeInput}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <FormControl style={{ width: '100%' }}>
                  <Controller
                    name="startDate"
                    control={control}
                    rules={{
                      required: 'Campo obligatorio',
                      validate: {
                        validDate: (value) => {
                          if (!moment(value, 'DD/MM/YYYY', true).isValid()) {
                            return 'Fecha inválida, el formato debe ser dd/MM/yyyy';
                          }
                          const minDate = moment('01/01/2000', 'DD/MM/YYYY');
                          const maxDate = startDateParams.isBeyondOneMonth ? moment().add(startDateParams.quantity, startDateParams.dateUnit) : moment();
                          const selectedDate = moment(value, 'DD/MM/YYYY');
                          if (selectedDate.isBefore(minDate)) {
                            return 'Fecha mínima permitida 01/01/2000';
                          }
                          if (selectedDate.isAfter(maxDate)) {
                            return `Fecha máxima permitida ${maxDate.format('DD/MM/YYYY')}`;
                          }
                          return true;
                        },
                      },
                    }}
                    defaultValue={startDate}
                    render={() => (
                      <MuiPickersUtilsProvider locale={deLocale} utils={DateFnsUtils}>
                        <KeyboardDatePicker
                          className={classes.dateCustom}
                          variant="inline"
                          inputVariant="outlined"
                          format="dd/MM/yyyy"
                          label="Fecha inicio *"
                          size="small"
                          color="primary"
                          value={startDate}
                          maxDate={startDateParams.isBeyondOneMonth ? moment().add(startDateParams.quantity, startDateParams.dateUnit) : moment()}
                          onChange={(date) => {
                            setValue('endDate', '');
                            setEndDate(null);
                            setValue('startDate', moment(date));
                            setStartDate(moment(date));
                            setFormData((prevData) => ({
                              ...prevData,
                              startDate: moment(date),
                              endDate: null,
                            }));
                            if (moment(date, 'DD/MM/YYYY', true).isValid()
                              && !moment(date).isBefore(moment('01/01/2000', 'DD/MM/YYYY'))
                              && !moment(date).isAfter(startDateParams.isBeyondOneMonth ? moment().add(startDateParams.quantity, startDateParams.dateUnit) : moment())) {
                              clearErrors('startDate');
                            }
                          }}
                          autoOk
                          error={!!errors.startDate}
                          helperText={errors.startDate ? errors.startDate.message : ''}
                          InputProps={{
                            style: {
                              borderRadius: '10px',
                              boxShadow: '1px 5px 5px #d7d7d7',
                            },
                          }}
                        />
                      </MuiPickersUtilsProvider>
                    )}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} md={6}>
                <FormControl style={{ width: '100%' }}>
                  <Controller
                    name="endDate"
                    control={control}
                    rules={{
                      required: 'Campo obligatorio',
                      validate: {
                        validDate: (value) => {
                          const minDate = startDate ? moment(startDate).startOf('day') : moment().startOf('day');
                          const maxDate = startDate ? moment(startDate).add(parameterMaxValidityContract, 'years').startOf('day') : moment().startOf('day');
                          const parsedValue = moment(value, 'DD/MM/YYYY', true).startOf('day');
                          if (!parsedValue.isValid()) {
                            return 'Fecha inválida, el formato debe ser dd/MM/yyyy';
                          }
                          if (parsedValue.isBefore(minDate)) {
                            return `La fecha debe ser posterior a ${minDate.format('DD/MM/YYYY')}`;
                          }
                          if (parsedValue.isAfter(maxDate)) {
                            return `La fecha no puede ser mayor a ${maxDate.format('DD/MM/YYYY')}`;
                          }
                          return true;
                        },
                      },
                    }}
                    defaultValue={endDate}
                    render={() => (
                      <MuiPickersUtilsProvider locale={deLocale} utils={DateFnsUtils}>
                        <KeyboardDatePicker
                          className={classes.dateCustom}
                          variant="inline"
                          inputVariant="outlined"
                          format="dd/MM/yyyy"
                          label="Fecha fin *"
                          size="small"
                          color="primary"
                          value={endDate}
                          minDate={startDate && moment(startDate).isAfter(moment()) ? moment(startDate).add(1, 'days') : moment()}
                          maxDate={startDate ? moment(startDate).add(parameterMaxValidityContract, 'years') : moment()}
                          onChange={(date) => {
                            setValue('endDate', moment(date));
                            setEndDate(moment(date));
                            setFormData((prevData) => ({
                              ...prevData,
                              endDate: moment(date),
                            }));
                            clearErrors('endDate');
                          }}
                          autoOk
                          error={!!errors.endDate}
                          helperText={errors.endDate ? errors.endDate.message : ''}
                          InputProps={{
                            style: {
                              borderRadius: '10px',
                              boxShadow: '1px 5px 5px #d7d7d7',
                            },
                          }}
                        />
                      </MuiPickersUtilsProvider>
                    )}
                  />
                </FormControl>
              </Grid>
            </Grid>
            <Grid container spacing={3} style={{ paddingTop: 20, paddingBottom: 20 }}>
              <Grid item xs={6}>
                <InputLabel />
                <CustomSelect
                  label="Gestor operativo"
                  name="gestorService"
                  options={gestorType}
                  control={control}
                  required
                  rule={Rules.required}
                  error={errors}
                  styleFromHelperText={{ style: { marginRight: 10 } }}
                  inputProps={{ onChange: (e) => setGestorType(e) }}
                  classes={classes.typeInput}
                />
              </Grid>
              <Grid item xs={6} md={6}>
                <InputLabel />
                <CustomSelect
                  label="Condición de pago"
                  name="paymentService"
                  options={listPaymentTypeContracts}
                  control={control}
                  required
                  rule={Rules.required}
                  error={errors}
                  styleFromHelperText={{ style: { marginRight: 10 } }}
                  inputProps={{ onChange: (e) => setPaymentType(e) }}
                  classes={classes.typeInput}
                />
              </Grid>
              {selectInhibitList && (
                <Grid item xs={6}>
                  <InputLabel />
                  <CustomSelect
                    label="Oficial de riesgo"
                    name="riskOfficer"
                    options={riskOfficers}
                    control={control}
                    required={riskOfficers ?? false}
                    rule={riskOfficers ? Rules.required : {}}
                    error={errors}
                    styleFromHelperText={{ style: { marginRight: 10 } }}
                    inputProps={{ onChange: (e) => setRiskOfficerType(e) }}
                    classes={classes.typeInput}
                  />
                </Grid>
              )}
              <Grid item xs={12} />
            </Grid>
          </>
        );
      case 1:
        return (
          <Grid container spacing={3} style={{ marginBottom: '32px' }}>
            <Grid item xs={12}>
              <Typography align="left" className={classes.titleForm} style={{ marginBottom: 20 }} variant="h6">
                Información cliente
              </Typography>
            </Grid>
            <Grid item xs={12} md={4}>
              <InputLabel />
              <CustomSelect
                label="Tipo de persona"
                name="personTypeService"
                options={personType}
                control={control}
                required
                rule={Rules.required}
                disabled={isEditAgreement}
                error={errors}
                styleFromHelperText={{ style: { marginRight: 10 } }}
                classes={classes.typeInput}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Grid container>
                <Grid item xs={12}>
                  <Controller
                    as={(
                      <TextField
                        select
                        label="Tipo Identificación"
                        size="small"
                        variant="outlined"
                        required
                        fullWidth
                        style={{ marginRight: 10, color: 'red' }}
                        FormHelperTextProps={{ style: { marginRight: 10 } }}
                        helperText={errors.documentTypeIdService ? errors.documentTypeIdService.message : ''}
                        className={classes.typeInput}
                      >
                        <MenuItem value="">Seleccione</MenuItem>
                        {
                          getDocumentTypesContracts(documentTypes, personTypeService, serviceNameSelected, listDocumentTypeContracts).map(
                            (td) => (
                              <MenuItem
                                key={td.value}
                                value={td.value}
                              >
                                {td.text}
                              </MenuItem>
                            ),
                          )
                        }
                      </TextField>
                    )}
                    name="documentTypeIdService"
                    control={control}
                    disabled={isEditAgreement}
                    rules={Rules.required}
                    error={Boolean(errors.documentTypeIdService)}
                    defaultValue=""
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} md={4}>
              <Grid container>
                <Grid item xs={watchDocTypeSer === 4 ? 9 : 12} sm={watchDocTypeSer === 4 ? 9 : 12}>
                  <CustomInput
                    label="No. Identificación"
                    name="documentNumberService"
                    control={control}
                    rule={validateDocument(personTypeService, watchDocTypeSer)}
                    disabled={isEditAgreement}
                    error={errors}
                    required
                    styleFromHelperText={{ style: { marginRight: 10 } }}
                    classes={classes.typeInput}
                  />
                </Grid>
                {watchDocTypeSer === 4 ? boxCheckDigit('dvService') : ''}
              </Grid>
            </Grid>
            {
              personTypeService === 'J'
                ? (
                  <Grid item xs={12}>
                    <CustomInput
                      label="Razón Social"
                      name="legalNameService"
                      control={control}
                      rule={Rules.DenySpecialCharactersLegalName}
                      error={errors}
                      disabled={isEditAgreement}
                      required
                      styleFromHelperText={{ style: { marginRight: 10 } }}
                      inputProps={{
                        maxLength: 450,
                      }}
                      classes={classes.typeInput}
                    />
                  </Grid>
                ) : (
                  <>
                    <Grid item xs={12} md={6}>
                      <CustomInput
                        label="Nombres"
                        name="firstNameService"
                        control={control}
                        rule={Rules.letrasTildesMin3}
                        error={errors}
                        disabled={isEditAgreement}
                        required
                        styleFromHelperText={{ style: { marginRight: 10 } }}
                        inputProps={{
                          maxLength: 100,
                        }}
                        classes={classes.typeInput}
                      />
                    </Grid>
                    <Grid item xs={12} lg={6}>
                      <CustomInput
                        label="Apellidos"
                        name="lastNameService"
                        control={control}
                        rule={Rules.letrasTildesMin3}
                        error={errors}
                        disabled={isEditAgreement}
                        required
                        styleFromHelperText={{ style: { marginRight: 10 } }}
                        inputProps={{
                          maxLength: 100,
                        }}
                        classes={classes.typeInput}
                      />
                    </Grid>
                  </>
                )
            }
            <Grid item xs={12} md={6}>
              {tenant || countryCodeUnique !== 'CO' ? (
                // If tenant show Input Without assistant
                <CustomInput
                  label={applicationInfo?.labelStreet || 'Dirección'}
                  name="fulladdressService"
                  control={control}
                  error={errors}
                  disabled={isEditAgreement}
                  required
                  rule={Rules.max200Characters}
                  styleFromHelperText={{ style: { marginRight: 10 } }}
                  classes={classes.typeInput}
                />
              ) : (
                // If tenant is null, show other component.
                <AutocompleteGoogleMaps
                  name="fulladdressService"
                  options={optionsAddressService}
                  disabled={!(statesAndCities && Object.keys(statesAndCities).length > 0) || isEditAgreement}
                  label={applicationInfo?.labelStreet || 'Dirección'}
                  placeholder={`Escriba la ${(applicationInfo?.labelStreet || 'dirección').toLowerCase()}`}
                  value={addressMapsService}
                  setOptions={setOptionsAddressService}
                  setValueMaps={setAddressMapsService}
                  inputValue={inputAddressServiceValue}
                  setInputValue={setInputAddressServiceValue}
                  setGeoCoordinate={setGeoCodeService}
                  type="Service"
                  showIconLocation
                  control={control}
                  rules={Rules.required}
                  error={errors}
                  className={classes.typeInput}
                />
              )}
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
              <Controller
                render={(props) => (
                  <Autocomplete
                    // eslint-disable-next-line react/jsx-props-no-spreading
                    {...props}
                    options={departaments}
                    noOptionsText="No hay registros"
                    size="small"
                    disableClearable
                    required
                    fullWidth
                    getOptionLabel={(option) => option.text}
                    renderInput={(params) => (
                      <TextField
                        // eslint-disable-next-line react/jsx-props-no-spreading
                        {...params}
                        label={applicationInfo?.labelRegion || 'Departamento'}
                        variant="outlined"
                        required
                        error={Boolean(errors.departmentIdService)}
                        style={{ marginRight: 10, color: 'red' }}
                        FormHelperTextProps={{ style: { marginRight: 10 } }}
                        helperText={errors.departmentIdService ? errors.departmentIdService.message : ''}
                        className={classes.typeInput}
                      />
                    )}
                    value={valueDepartamentService}
                    disabled={isEditAgreement}
                    onChange={(_, data) => {
                      // eslint-disable-next-line react/destructuring-assignment
                      props.onChange(data);
                      if (data) {
                        setValueDepartamentService(data);
                        handleChangeStateCustomerServiceId(data.value);
                      }
                    }}
                  />
                )}
                defaultValue=""
                name="departmentIdService"
                control={control}
                rules={Rules.required}
              />
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
              <Controller
                render={(props) => (
                  <Autocomplete
                    {...props}
                    options={citiesService}
                    noOptionsText="No hay registros"
                    disableClearable
                    size="small"
                    required
                    fullWidth
                    getOptionLabel={(option) => option.cityName}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={applicationInfo?.labelCity || 'Ciudad'}
                        variant="outlined"
                        required
                        error={Boolean(errors.cityIdService)}
                        style={{ marginRight: 10, color: 'red' }}
                        FormHelperTextProps={{ style: { marginRight: 10 } }}
                        helperText={errors.cityIdService ? errors.cityIdService.message : ''}
                        className={classes.typeInput}
                      />
                    )}
                    value={valueCityService}
                    disabled={isEditAgreement}
                    onChange={(_, data) => {
                      props.onChange(data);
                      if (data) {
                        setValueCityService(data);
                      }
                    }}
                  />
                )}
                defaultValue=""
                name="cityIdService"
                control={control}
                rules={Rules.required}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <CustomInput
                label="Teléfono / Celular"
                name="cellphoneNumberService"
                control={control}
                rule={Rules.telCel}
                error={errors}
                required
                styleFromHelperText={{ style: { marginRight: 10 } }}
                inputProps={{
                  maxLength: 10,
                }}
                onValidate={(e) => {
                  const { value } = e.target;
                  setFormData((prevData) => ({
                    ...prevData,
                    cellphoneNumberService: value,
                  }));
                }}
                classes={classes.typeInput}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <CustomInput
                label="Correo Electrónico"
                name="emailService"
                control={control}
                rule={{
                  ...Rules.email,
                  validate: validateEmail, // personalizated validation
                }}
                error={errors}
                required
                styleFromHelperText={{ style: { marginRight: 10 } }}
                inputProps={{
                  maxLength: 100,
                }}
                classes={classes.typeInput}
                onValidate={(e) => {
                  const { value } = e.target;
                  setFormData((prevData) => ({
                    ...prevData,
                    emailService: value,
                  }));
                }}
              />
            </Grid>
            {
              showLegalRepresentativeContract && personTypeService === 'J'
                ? (
                  <>
                    <Grid item xs={12}>
                      <Typography align="left" className={classes.titleForm} style={{ marginBottom: 20 }} variant="h6">
                        Datos representante legal
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Controller
                        as={(
                          <TextField
                            select
                            label="Tipo documento"
                            size="small"
                            variant="outlined"
                            required
                            fullWidth
                            style={{ marginRight: 10, color: 'red' }}
                            FormHelperTextProps={{ style: { marginRight: 10 } }}
                            helperText={errors.legalDocumentTypeIdService ? errors.legalDocumentTypeIdService.message : ''}
                            className={classes.typeInput}
                          >
                            <MenuItem value="">Seleccione</MenuItem>
                            {
                              documentTypes && documentTypes.filter((doc) => doc.value === 1 || doc.value === 2 || doc.value === 6).map(
                                (td) => (
                                  <MenuItem
                                    key={td.value}
                                    value={td.value}
                                  >
                                    {td.text}
                                  </MenuItem>
                                ),
                              )
                            }
                          </TextField>
                        )}
                        disabled={isEditAgreement}
                        name="legalDocumentTypeIdService"
                        control={control}
                        rules={Rules.required}
                        error={Boolean(errors.legalDocumentTypeIdService)}
                        defaultValue=""
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Controller
                        as={(
                          <TextField
                            label="Número documento"
                            size="small"
                            variant="outlined"
                            required
                            fullWidth
                            style={{ marginRight: 10, color: 'red' }}
                            FormHelperTextProps={{ style: { marginRight: 10 } }}
                            helperText={errors.legalDocumentNumberService ? errors.legalDocumentNumberService.message : ''}
                            className={classes.typeInput}
                          />
                        )}
                        disabled={isEditAgreement}
                        name="legalDocumentNumberService"
                        control={control}
                        rules={validateDocument('J', watchLegalDocTypeSer)}
                        error={Boolean(errors.legalDocumentNumberService)}
                        defaultValue=""
                        inputProps={{ maxLength: 15 }}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Controller
                        as={(
                          <TextField
                            label="Nombres"
                            size="small"
                            variant="outlined"
                            required
                            fullWidth
                            style={{ marginRight: 10, color: 'red' }}
                            FormHelperTextProps={{ style: { marginRight: 10 } }}
                            helperText={errors.legalFirstNameService ? errors.legalFirstNameService.message : ''}
                            className={classes.typeInput}
                          />
                        )}
                        disabled={isEditAgreement}
                        name="legalFirstNameService"
                        control={control}
                        rules={Rules.letrasTildesMin3}
                        error={Boolean(errors.legalFirstNameService)}
                        defaultValue=""
                        inputProps={{ maxLength: 100 }}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Controller
                        as={(
                          <TextField
                            label="Apellidos"
                            size="small"
                            variant="outlined"
                            required
                            fullWidth
                            style={{ marginRight: 10, color: 'red' }}
                            FormHelperTextProps={{ style: { marginRight: 10 } }}
                            helperText={errors.legalLastNameService ? errors.legalLastNameService.message : ''}
                            className={classes.typeInput}
                          />
                        )}
                        disabled={isEditAgreement}
                        name="legalLastNameService"
                        control={control}
                        rules={Rules.letrasTildesMin3}
                        error={Boolean(errors.legalLastNameService)}
                        defaultValue=""
                        inputProps={{ maxLength: 100 }}
                      />
                    </Grid>
                  </>
                ) : (
                  <></>
                )
            }
          </Grid>
        );
      case 2:
        return (
          <Grid container spacing={3} alignItems="center" style={{ marginBottom: '32px' }}>
            <Grid item xs={12}>
              <Typography align="left" className={classes.titleForm} style={{ marginBottom: 20 }} variant="h6">
                Información supervisor
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <CustomSelect
                label="Tipo Identificación"
                name="documentTypeIdSupervisor"
                // eslint-disable-next-line no-nested-ternary
                options={getDocumentsTypesSupervisor()}
                control={control}
                required
                rule={Rules.required}
                error={errors}
                styleFromHelperText={{ style: { marginRight: 10 } }}
                inputProps={{ onChange: (e) => setDocumentTypeSupervisor(e) }}
                classes={classes.typeInput}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <CustomInput
                label="No. Identificación:"
                name="documentNumberSupervisor"
                control={control}
                error={errors}
                required
                rule={validateDocument('N', watchDocTypeDocSupervisor)}
                styleFromHelperText={{ style: { marginRight: 10 } }}
                inputProps={{
                  onBlur: () => {
                    loadSupervisorInfo(watchDocTypeDocSupervisor, watchDocuNumberSupervisor, listDocumentTypeContracts[0]?.countryCode || 'COL');
                  },
                }}
                classes={classes.typeInput}
                onValidate={(e) => {
                  const { value } = e.target;
                  setFormData((prevData) => ({
                    ...prevData,
                    documentNumberSupervisor: value,
                  }));
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <CustomInput
                label="Nombres: "
                name="namesSupervisor"
                control={control}
                error={errors}
                required
                rule={Rules.letrasTildesMin3}
                styleFromHelperText={{ style: { marginRight: 10 } }}
                classes={classes.typeInput}
                onValidate={(e) => {
                  const { value } = e.target;
                  setFormData((prevData) => ({
                    ...prevData,
                    namesSupervisor: value,
                  }));
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <InputLabel />
              <CustomInput
                label="Apellidos: "
                name="lastNameSupervisor"
                control={control}
                error={errors}
                required
                rule={Rules.letrasTildesMin3}
                styleFromHelperText={{ style: { marginRight: 10 } }}
                classes={classes.typeInput}
                onValidate={(e) => {
                  const { value } = e.target;
                  setFormData((prevData) => ({
                    ...prevData,
                    lastNameSupervisor: value,
                  }));
                }}
              />
            </Grid>
            <AutoCompleteAddressDepartmentCity
              control={control}
              errors={errors}
              styles={classes.typeInput}
              setValue={setValue}
              getValues={getValues}
              addressMapsSon={addressMapsSon}
              setAddressMapsSon={setAddressMapsSon}
              inputAddressSonValue={inputAddressSonValue}
              setInputAddressSonValue={setInputAddressSonValue}
              tenant={tenant || (countryCodeUnique !== 'CO' && countryCodeUnique)}
              stylesForInput={classes.typeInput}
              optionsAddressService={optionsAddressSupervisor}
              setOptionsAddressService={setOptionsAddressSupervisor}
              departaments={departamentsSupervisor}
              setDepartaments={setDepartamentsSupervisor}
              setGeoCodeService={setGeoCodeSupervisor}
              valueDepartamentService={valueDepartamentSupervisor}
              setValueDepartamentService={setValueDepartamentSupervisor}
              valueCityService={valueCitySupervisor}
              setValueCityService={setValueCitySupervisor}
              citiesService={citiesSupervisor}
              setCitiesService={setCitiesSupervisor}
              onChangeDepartmentSupervisor={onChangeDepartmentSupervisor}
              onChangeCitySupervisor={onChangeCitySupervisor}
              onChangeFulladdressSupervisor={onChangeFulladdressSupervisor}
              statesAndCities={statesAndCities}
              setFormData={setFormData}
              applicationInfo={applicationInfo}
            />
            <Grid item xs={12} md={6}>
              <CustomInput
                label="Teléfono / Celular"
                name="cellphoneNumberSupervisor"
                control={control}
                error={errors}
                rule={Rules.telCelWithoutRequired}
                styleFromHelperText={{ style: { marginRight: 10 } }}
                inputProps={{
                  maxLength: 10,
                  Rules: Rules.telCel,
                }}
                classes={classes.typeInput}
                onValidate={(e) => {
                  const { value } = e.target;
                  setFormData((prevData) => ({
                    ...prevData,
                    cellphoneNumberSupervisor: value,
                  }));
                }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <CustomInput
                label="Correo Electrónico"
                name="emailSupervisor"
                control={control}
                rule={{
                  ...Rules.email,
                  validate: validateEmail, // personalizated validation
                }}
                error={errors}
                required
                styleFromHelperText={{ style: { marginRight: 10 } }}
                inputProps={{
                  maxLength: 100,
                }}
                classes={classes.typeInput}
                onValidate={(e) => {
                  const { value } = e.target;
                  setFormData((prevData) => ({
                    ...prevData,
                    emailSupervisor: value,
                  }));
                }}
                disabled={hasSupervisorEmail && isEditAgreement}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <InputLabel />
              <CustomInput
                label="Cargo del supervisor"
                name="supervisorPosition"
                control={control}
                error={errors}
                rule={Rules.textoNumerosTildes}
                styleFromHelperText={{ style: { marginRight: 10 } }}
                inputProps={{
                  maxLength: 100,
                }}
                classes={classes.typeInput}
                onValidate={(e) => {
                  const { value } = e.target;
                  setFormData((prevData) => ({
                    ...prevData,
                    supervisorPosition: value,
                  }));
                }}
              />
            </Grid>
          </Grid>
        );
      case 3:
        return selectComponent();
      case 4:
        return (
          <AlertPeriodicity
            formActions={{
              controlForm: control,
              errorsForm: errors,
              setValueForm: setValue,
              getValuesForm: getValues,
              setValuesInForm: setFormData,
              valuesInForm: formData,
            }}
            alertPeriodicityParams={alertPeriodicityParams}
          />
        );
      default:
        return 'Paso no encontrado';
    }
  };

  if (loading) return <Loading />;

  return (
    <Container component="main" maxWidth="lg">
      <Paper elevation={3} className={classes.paper}>
        <Typography color="primary" variant="h4" className={classes.title}>
          Convenios
        </Typography>
        <Container component="main" maxWidth="lg">
          <Paper elevation={3} className={classes.paperGroup}>
            {
              Object.keys(getInformationAgreementResponse).length > 0 ? (
                <>
                  <form
                    noValidate
                    autoComplete="off"
                    onSubmit={handleSubmit(handleNext)}
                  >
                    <Grid item xs={12} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <Grid item xs={0}>
                        <IconButton color="primary" style={{ color: theme.palette.secondary.main }} onClick={() => window.location.reload()}>
                          <ArrowBackIosIcon />
                        </IconButton>
                      </Grid>
                      <Grid item xs={12}>
                        <Typography align="left" className={classes.titleFormAgreement} variant="h5">
                          Editar Convenio
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid container spacing={4} style={{ paddingLeft: '36px', paddingRight: '36px' }}>
                      <Grid container justifyContent="center" style={{ marginBottom: '20px', paddingTop: '10px' }}>
                        <Grid item>
                          <Stepper nonLinear activeStep={activeStep} alternativeLabel style={{ display: 'flex', justifyContent: 'center' }}>
                            {steps.map((label, index) => (
                              <Step key={label}>
                                <StyledStepButton
                                  disabled={(index === 1 || index === 2) && isLoadingInfo}
                                  onClick={async () => {
                                    setIsCheckedButtonChanges(false);
                                    const isValid = await trigger();
                                    if (isValid) {
                                      if (_.isEqual(formData, formCopy) && _.isEqual(servicesToAdd, servicesToAddCopy)) {
                                        setActiveStep(index);
                                      } else {
                                        setOpenAlertConfirmTab(true);
                                        setActiveStepAux(index);
                                      }
                                    }
                                  }}
                                >
                                  {label}
                                </StyledStepButton>
                              </Step>
                            ))}
                          </Stepper>
                        </Grid>
                      </Grid>
                      {renderStepContent(activeStep)}
                      <Grid container spacing={2} style={{ alignItems: 'center' }}>
                        <Grid item xs={12} md={6} className={classes.subGridButtonsCancel}>
                          <Box className={classes.submit} display="flex" justifyContent="flex-start">
                            <Button
                              variant="contained"
                              color="inherit"
                              size="medium"
                              className={classes.btnSubmitCancel}
                              onClick={() => handleCancel()}
                              disabled={_.isEqual(formData, formCopy) && _.isEqual(servicesToAdd, servicesToAddCopy)}
                            >
                              Cancelar
                            </Button>
                          </Box>
                        </Grid>
                        <Grid item xs={12} md={6} className={classes.subGridButtons}>
                          <Box className={classes.submit} display="flex" justifyContent="flex-end">
                            <Button
                              type="submit"
                              variant="contained"
                              color="primary"
                              size="medium"
                              className={classes.btnBlueSubmit}
                              disabled={_.isEqual(formData, formCopy) && _.isEqual(servicesToAdd, servicesToAddCopy)}
                            >
                              Guardar Cambios
                            </Button>
                          </Box>
                        </Grid>
                        <Grid item xs={12} />
                      </Grid>
                    </Grid>
                  </form>
                  <AlertConfirm
                    isOpen={openAlertConfirmTab}
                    tituloModal="Se realizaron cambios en el convenio, ¿Deseas guardarlos?"
                    handleAccept={() => handleConfirmChecked()}
                    onCancel
                    onClose={() => handleCancelModify()}
                    textButtonCancel="Cancelar"
                    textButtonAcept="Guardar"
                    messageAlert={alertStyles(theme, OwnWarningIcon, '508px', '369px', 40)}
                    showClose={false}
                    disabled={disabledButton}
                  />
                  <ObservationsConfirm
                    isOpen={openAlertConfirmTicket}
                    textTitle="Ingresa el Número del ticket"
                    firstImage={OwnWarningIcon}
                    objControl={{
                      control,
                      errors,
                    }}
                    objInputs={{
                      label1: 'Número de ticket',
                      name1: 'ticketService',
                      label2: 'Observaciones',
                      name2: 'observations',
                    }}
                    objButtons={{
                      textCancel: 'Cancelar',
                      textAccept: disabledButton ? getLoading() : 'Guardar',
                      handleCancel: () => handleCancelModifyTicket(),
                      handleAccept: () => handleConfirmTicket(),
                      styleButtonAccept: {
                        width: '116px',
                        backgroundColor: theme?.backOffice?.contracts?.btnSteps?.backgroundColor,
                        color: '#FFFF',
                      },
                      styleButtonCancel: {
                        backgroundColor: '#FFFFFF',
                        color: theme?.backOffice?.contracts?.btnSteps?.backgroundColor,
                        border: `1px solid ${theme?.backOffice?.contracts?.btnSteps?.backgroundColor}`,
                        width: '116px',
                      },
                    }}
                  />
                  <AlertConfirm
                    isOpen={messagesAlertViewOpen}
                    tituloModal={messagesAlertView?.tituloModal}
                    textButtonAcept={messagesAlertView?.textButtonAcept}
                    mensajeModal={messagesAlertView?.mensajeModal}
                    handleAccept={messagesAlertView?.handleAccept}
                    onCancel={messagesAlertView?.onCancel}
                    onClose={messagesAlertView?.onClose}
                    messageAlert={messagesAlertView?.messageAlert}
                    showClose={messagesAlertView?.showClose}
                    isOnlyMessage={messagesAlertView?.isOnlyMessage}
                  />
                </>
              ) : (
                <>
                  <div style={{ display: 'flex', justifyContent: 'center', marginTop: '25px' }}>
                    <WarningIcon color={dialogColorIcon} />
                  </div>
                  <Typography
                    variant="h4"
                    style={{
                      display: 'flex', justifyContent: 'center', fontWeight: 700, color: '#E45501', fontSize: '25px', marginTop: '25px',
                    }}
                  >
                    ¡Lo sentimos!
                  </Typography>
                  <Typography
                    variant="h5"
                    style={{
                      display: 'flex', justifyContent: 'center', fontWeight: 500, color: '#575756', fontSize: '19px', marginTop: '25px',
                    }}
                  >
                    En el momento no es posible obtener esta
                  </Typography>
                  <Typography
                    variant="h5"
                    style={{
                      display: 'flex', justifyContent: 'center', fontWeight: 500, color: '#575756', fontSize: '19px',
                    }}
                  >
                    información, por favor inténtalo más tarde.
                  </Typography>
                  <Box display="flex" justifyContent="center" marginTop="25px" marginBottom="25px">
                    <Button
                      type="button"
                      variant="contained"
                      color="primary"
                      size="medium"
                      className={classes.btnBlueSubmit}
                      onClick={() => window.location.reload()}
                    >
                      Aceptar
                    </Button>
                  </Box>
                </>
              )
            }
          </Paper>
        </Container>
      </Paper>
    </Container>
  );
};

const mapStateToProps = (props) => ({
  appName: props.general.appName,
  tenant: props.general.tenant,
  statesAndCities: props.general.statesAndCities,
  citiesServGoogleAssistant: props.google.citiesServGoogleAssistant,
  documentTypes: props.general.documentTypes,
  gestorType: props.license.gestorType,
  productType: props.home.productType,
  listPaymentTypeContracts: props.license.listPaymentTypeContracts,
  listDocumentTypeContracts: props.license.listDocumentTypeContracts,
  listValidityTypeContracts: props.license.listValidityTypeContracts,
  listDeviceTypeContracts: props.license.listDeviceTypeContracts,
  listCredentialDeliveryContracts: props.license.listCredentialDeliveryContracts,
  parameterMaxReassignmentQuota: props.license.parameterMaxReassignmentQuota,
  parameterMaxValidityContract: props.license.parameterMaxValidityContract,
  showLegalRepresentativeContract: props.license.showLegalRepresentativeContract,
  startDateParams: props.license.startDateParams,
  transformedListMaxValidityAmountContracts: props.license.transformedListMaxValidityAmountContracts,
  emailsInBalckList: props.emails.emailsBlackList,
  contractData: props.license.getContractData,
  decodedToken: props.auth.decodedToken,
  servicesCombo: props.service.servicesCombo,
  showMessageAlert: props.general.showMessageAlert,
  getInformationAgreementResponse: props.license.getInformationAgreementResponse,
  modifyInformationAgreementResponse: props.license.modifyInformationAgreementResponse,
  loading: props.license.loading,
  alertPeriodicityParams: props.license.alertPeriodicityParams,
  riskOfficers: props.license.riskOfficers,
  riskOfficerRole: props.license.riskOfficerRole,
  listCredentialParams: props.license.listCredentialParams,
  applicationInfo: props.general.applicationInfo,
});

const mapDispatchToProps = {
  getPurchaseOrderParameters: getPurchaseOrderParametersAction,
  saveContract: saveContractAction,
  getManagers: getManagersAction,
  getPackagesContracts: getPackagesContractsAction,
  getAppParametersContracts: getAppParametersContractsAction,
  getBlackListEmails: getBlackListEmailsAction,
  getContractData: getContractDataAction,
  getContractCustomerInfo: getContractCustomerInfoAction,
  getContractSupervisiorInfo: getContractSupervisiorInfoAction,
  getInformationAgreement: getInformationAgreementAction,
  modifyInformationAgreement: modifyInformationAgreementAction,
  getServices: getServicesAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(EditAgreements);
